import { objectWithoutProperties as _objectWithoutProperties, objectSpread2 as _objectSpread2, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.esm.js';
import React__default, { forwardRef, useMemo } from 'react';
import { composeRenderProps, Button as Button$2 } from 'react-aria-components';
import getPendingButtonLayout from './pending-button-layout.esm.js';
import { useComponentVariant } from '../../theme/variant.context.esm.js';
import { useComponentTheme } from '../../theme/theme.context.esm.js';

var _excluded = ["variant"],
  _excluded2 = ["alignItems", "className", "color", "hoverMode", "inheritColor", "inheritFontSize", "isDisabled", "justify", "noBorder", "orientation", "size", "testId", "variant", "loadingText", "children"];
var Button = /*#__PURE__*/forwardRef(function Button(_ref, ref) {
  var _ref$variant = _ref.variant,
    variantPreSet = _ref$variant === void 0 ? 'primary' : _ref$variant,
    props = _objectWithoutProperties(_ref, _excluded);
  var variantProps = useComponentVariant('Button', variantPreSet);
  var theme = useComponentTheme('Button');
  var _variantProps$props = _objectSpread2(_objectSpread2({}, variantProps), props),
    alignItems = _variantProps$props.alignItems,
    _variantProps$props$c = _variantProps$props.className,
    _className = _variantProps$props$c === void 0 ? '' : _variantProps$props$c,
    color = _variantProps$props.color,
    hoverMode = _variantProps$props.hoverMode,
    inheritColor = _variantProps$props.inheritColor,
    inheritFontSize = _variantProps$props.inheritFontSize,
    isDisabled = _variantProps$props.isDisabled,
    justify = _variantProps$props.justify,
    noBorder = _variantProps$props.noBorder,
    _variantProps$props$o = _variantProps$props.orientation,
    orientation = _variantProps$props$o === void 0 ? 'horizontal' : _variantProps$props$o,
    _variantProps$props$s = _variantProps$props.size,
    size = _variantProps$props$s === void 0 ? 'std' : _variantProps$props$s,
    testId = _variantProps$props.testId,
    variant = _variantProps$props.variant,
    loadingText = _variantProps$props.loadingText,
    _children = _variantProps$props.children,
    rest = _objectWithoutProperties(_variantProps$props, _excluded2);
  var hasOnPressListener = !!props.onPress;
  var classes = useMemo(function () {
    return composeRenderProps(_className, function (className, renderProps) {
      var classes = theme(_objectSpread2(_objectSpread2({}, renderProps), {}, {
        alignItems: alignItems,
        color: color,
        hoverMode: hoverMode,
        inheritColor: inheritColor,
        inheritFontSize: inheritFontSize,
        justify: justify,
        noBorder: noBorder,
        nonInteractive: !hasOnPressListener,
        orientation: orientation,
        size: size,
        variant: variant,
        className: className
      }));
      return "csg-tw-button ".concat(classes);
    });
  }, [_className, alignItems, color, hasOnPressListener, hoverMode, inheritColor, inheritFontSize, justify, noBorder, orientation, size, theme, variant]);
  var children = useMemo(function () {
    if (loadingText) {
      return getPendingButtonLayout({
        orientation: orientation,
        color: color,
        children: _children,
        loadingText: loadingText
      });
    }
    return _children;
  }, [_children, color, orientation, loadingText]);
  return /*#__PURE__*/React__default.createElement(Button$2, _extends({
    className: classes,
    ref: ref,
    "data-testid": testId,
    isDisabled: isDisabled
  }, rest), children);
});
Button.displayName = 'Button';
var Button$1 = Button;

export { Button$1 as default };
//# sourceMappingURL=button.esm.js.map
